"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyHolderResidenceStatus = void 0;
var PolicyHolderResidenceStatus;
(function (PolicyHolderResidenceStatus) {
    PolicyHolderResidenceStatus["OWN_SINGLE_FAMILY"] = "OwnSingleFamily";
    PolicyHolderResidenceStatus["OWN_CONDO"] = "OwnCondo";
    PolicyHolderResidenceStatus["OWN_MOBILE_HOME"] = "OwnMobileHome";
    PolicyHolderResidenceStatus["LIVE_WITH_PARENTS"] = "LiveWithParents";
    PolicyHolderResidenceStatus["RENT"] = "Rent";
    PolicyHolderResidenceStatus["OTHER"] = "Other";
})(PolicyHolderResidenceStatus = exports.PolicyHolderResidenceStatus || (exports.PolicyHolderResidenceStatus = {}));
